var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "w-100 h-100",
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('b-container', {
    staticClass: "p-0 align-content-start d-flex",
    attrs: {
      "fluid": ""
    }
  }, [_c('create-event-form', {
    attrs: {
      "error": _vm.eventError,
      "projects": _vm.getProjects,
      "is-update": _vm.isUpdate,
      "item": _vm.item
    },
    on: {
      "submit": _vm.onSubmit,
      "close": _vm.close
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }